module.exports = __webpack_public_path__ + "static/media/docker.69298f56.svg";